/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import { Box, Typography, InputAdornment } from '@mui/material';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useDebounce } from 'use-lodash-debounce';
import { ROUTES } from '../../../../constants/routes';
import {
  BONUSES_STATUS,
  DISABLED_CONTROL_TOOLTIP,
  PERMISSIONS
} from '../../../../constants/variables';
import { ReactComponent as SearchIcon } from '../../../../assets/images/search.svg';
import { HEAD_CELLS } from '../../constants';
import EnhancedTable from '../../../../components/EnhancedTable';
import { BonusesTableBody } from '../../components/BonusesTableBody';
import { CustomSelect } from '../../../../components/CustomSelect';
import { CustomDatePicker } from '../../../../components/CustomDatePicker';
import { FirstTextSelect } from '../../../../components/FirstTextSelcet';
import { CustomButton } from '../../../../components/CustomButton';
import { CustomInput } from '../../../../components/CustomInput';
import { Tab } from '../../../../components/Tab';
import {
  approveCard,
  archivedCard,
  getEvents,
  getTriggers,
  onApproveCard
} from '../../../../store/bonuses/actions';
import { CustomModal } from '../../../../components/CustomModal';
import { visibleBySectionPermission } from '../../../../utils/visibleBySectionPermission';
import { NotFoundItems } from '../../../../components/NotFoundItems';
import { setUsersPermissions } from '../../../../utils/setUsersPermissions';
import { getEventDeclensionForm } from '../../../../utils/getEventDeclension';
import { ModalReason } from '../../components/ModalReason';
import { PackagesTab } from '../../components/PackagesTab';

const PROMOTIONS = 'PROMOTIONS';
const PACKAGES = 'PACKAGES';

const styleInput = {
  size: 'small',
  variant: 'outlined'
};

const propsSelect = (name, text, options, value) => ({
  name,
  options,
  value,
  startAdornmentText: <FirstTextSelect text={text} />,
  ...styleInput
});

export const Bonuses = () => {
  const [typeTab, setTypeTab] = useState(localStorage.getItem('bonusesTab') || PROMOTIONS);

  const dispatch = useDispatch();
  const { eventCards, triggers, fetching } = useSelector((state) => state.bonuses);
  const { userPermissions, currentUsersPermissions } = useSelector(
    (state) => state.userPermissions
  );
  const permissions = setUsersPermissions(userPermissions, currentUsersPermissions?.permissions);

  const triggersForFilter = triggers?.filter((trigger) => trigger.name !== 'Промокод');

  const [filter, setFilter] = useState({
    orderBy: 'id',
    orderType: 'desc',
    date_start: '',
    date_end: '',
    search: '',
    status: BONUSES_STATUS[0],
    trigger_id: { id: 'all', name: 'Все' },
    page: 0,
    size: 10,
    account_number: 'Все'
  });
  const [isSuccessModal, setIsSuccessModal] = useState(false);
  const [isOnApproveModal, setIsOnApproveModal] = useState(false);
  const [isApproveModal, setIsApproveModal] = useState(false);
  const [isRejectModal, setIsRejectModal] = useState(false);
  const [curID, setCurID] = useState('');

  const debouncedValue = useDebounce(filter.search, 800);

  const dateToStringForFilter = (date) =>
    `${date.getUTCFullYear()}-${
      date.getUTCMonth() + 1
    }-${date.getUTCDate()} ${date.getUTCHours()}:${date.getUTCMinutes()}`;

  const isNotVisibleByListOrSearchBonuses = !visibleBySectionPermission(permissions, [
    PERMISSIONS.BONUS.ListBonusCards.value,
    PERMISSIONS.BONUS.SearchBonusCards.value
  ]);
  const isNotVisibleByListOrFilterBonuses = !visibleBySectionPermission(permissions, [
    PERMISSIONS.BONUS.ListBonusCards.value,
    PERMISSIONS.BONUS.FilterBonusCards.value
  ]);
  const isNotVisibleByCreateBonusCards = !visibleBySectionPermission(
    permissions,
    PERMISSIONS.BONUS.CreateBonusCards.value
  );
  const isAllowedToListBonusCards = visibleBySectionPermission(
    permissions,
    PERMISSIONS.BONUS.ListBonusCards.value
  );
  const isAllowedToUpdateBonusCards = visibleBySectionPermission(
    permissions,
    PERMISSIONS.BONUS.UpdateBonusCards.value
  );
  const isAllowedToRetrieveBonusCards = visibleBySectionPermission(
    permissions,
    PERMISSIONS.BONUS.RetrieveBonusCards.value
  );
  const isAllowedToCopyBonusCards = visibleBySectionPermission(
    permissions,
    PERMISSIONS.BONUS.CopyBonusCards.value
  );
  const isAllowedToArchiveBonusCards = visibleBySectionPermission(
    permissions,
    PERMISSIONS.BONUS.ArchiveBonusCards.value
  );
  const isPageVisible = visibleBySectionPermission(
    permissions,
    [PERMISSIONS.BONUS.ListBonusCards.value, PERMISSIONS.BONUS.CreateBonusCards.value],
    'or'
  );

  useEffect(() => {
    if (isAllowedToListBonusCards) {
      dispatch(
        getEvents(
          visibleBySectionPermission(permissions, PERMISSIONS.BONUS.FilterBonusCards.value)
            ? {
                ...filter,
                page: filter.page + 1,
                date_start: filter.date_start.toString().length
                  ? dateToStringForFilter(filter.date_start)
                  : undefined,
                date_end: filter.date_end.toString().length
                  ? dateToStringForFilter(filter.date_end)
                  : undefined,
                status:
                  filter.status.value !== BONUSES_STATUS[0].value ? filter.status.value : undefined,
                trigger_id: filter.trigger_id.id !== 'all' ? filter.trigger_id.id : undefined,
                search: debouncedValue || undefined,
                account_number: filter.account_number === 'Все' ? undefined : filter.account_number,
                order_type: filter.orderType,
                order_by: filter.orderBy,
                size: filter.size
              }
            : {
                page: filter.page + 1,
                order_type: filter.orderType,
                order_by: filter.orderBy,
                size: filter.size
              }
        )
      );
    } // eslint-disable-next-line
  }, [
    debouncedValue,
    filter.status,
    filter.trigger_id,
    filter.date_start,
    filter.date_end,
    filter.orderType,
    filter.orderBy,
    filter.size,
    filter.page,
    filter.account_number,
    isAllowedToListBonusCards
  ]);

  useEffect(
    () => {
      !triggers.length && dispatch(getTriggers());
    }, // eslint-disable-next-line
    []
  );

  const handlerOnChange = (e, field) => setFilter({ ...filter, page: 0, [field]: e });

  const handleArchiver = () => {
    dispatch(archivedCard(curID));
    setIsSuccessModal(false);
  };

  const handleOnApprove = () => {
    dispatch(onApproveCard(curID));
    setIsOnApproveModal(false);
  };

  const handleApprove = () => {
    dispatch(approveCard(curID, { status: 'Одобрена' }));
    setIsApproveModal(false);
  };

  const handleReject = (reason) => {
    dispatch(approveCard(curID, { status: 'Доработка', reason }));
    setIsRejectModal(false);
  };

  if (!isPageVisible) {
    return <></>;
  }

  return (
    <Box id="bonus-list">
      <Typography
        mb="24px"
        variant="h1"
        sx={{ color: 'text.primary' }}
        component="h1"
        data-testid="Title">
        Бонусы
      </Typography>

      <Box display="flex" justifyContent="space-between">
        <Box display="flex">
          <Tab
            label="Акции"
            setTypeTable={() => setTypeTab(PROMOTIONS)}
            typeCurrent={typeTab}
            typeDefault={PROMOTIONS}
          />
          <Tab
            label="Пакеты"
            setTypeTable={() => setTypeTab(PACKAGES)}
            typeCurrent={typeTab}
            typeDefault={PACKAGES}
          />
        </Box>
      </Box>

      {typeTab === PROMOTIONS ? (
        <>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            m="24px 0px"
            data-testid="AddPromotion">
            <CustomButton
              component={Link}
              to={ROUTES.BONUSES_ADD_EVENT}
              size="large"
              variant="contained"
              disabled={isNotVisibleByCreateBonusCards}
              tooltip={isNotVisibleByCreateBonusCards ? DISABLED_CONTROL_TOOLTIP : null}>
              Добавить событие
            </CustomButton>

            <CustomInput
              value={filter.search}
              onChange={(e) => setFilter({ ...filter, search: e.target.value, page: 0 })}
              {...styleInput}
              type="search"
              placeholder="Поиск"
              disabled={isNotVisibleByListOrSearchBonuses}
              tooltip={isNotVisibleByListOrSearchBonuses ? DISABLED_CONTROL_TOOLTIP : null}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                )
              }}
            />
          </Box>

          <Box display="grid" gridTemplateColumns="1fr 1fr 1fr 1fr" gap="16px" data-testid="Grid">
            <CustomSelect
              {...propsSelect('status', 'Статус:', BONUSES_STATUS, filter.status)}
              onChange={(e) => handlerOnChange(e, 'status')}
              disabled={isNotVisibleByListOrFilterBonuses}
              tooltip={isNotVisibleByListOrFilterBonuses ? DISABLED_CONTROL_TOOLTIP : null}
            />

            <CustomSelect
              {...propsSelect(
                'trigger_id',
                'Триггер:',
                [{ id: 'all', name: 'Все' }, ...triggersForFilter],
                filter.trigger_id
              )}
              onChange={(e) => handlerOnChange(e, 'trigger_id')}
              disabled={isNotVisibleByListOrFilterBonuses}
              tooltip={isNotVisibleByListOrFilterBonuses ? DISABLED_CONTROL_TOOLTIP : null}
            />

            <CustomDatePicker
              name="date_start"
              value={filter.date_start || ' '}
              onChange={(e) => {
                handlerOnChange(e || '', 'date_start');
              }}
              fixedPlaceholderText="Дата начала:"
              inputProps={{ 'data-testid': 'date-start' }}
              {...styleInput}
              disabled={isNotVisibleByListOrFilterBonuses}
              offLastDate={false}
              previousDate
            />

            <CustomDatePicker
              name="date_end"
              value={filter.date_end || ' '}
              onChange={(e) => handlerOnChange(e || '', 'date_end')}
              fixedPlaceholderText="Дата окончания:"
              inputProps={{ 'data-testid': 'date-end' }}
              {...styleInput}
              disabled={isNotVisibleByListOrFilterBonuses}
              offLastDate={false}
              previousDate
            />
          </Box>

          {isAllowedToListBonusCards ? (
            fetching || eventCards?.items?.length ? (
              <>
                <Typography color="text.secondary" m="24px 0px" data-testid="FoundEvents">
                  Найдено {getEventDeclensionForm(eventCards?.items?.length, 'event')}
                </Typography>

                <EnhancedTable
                  rows={eventCards?.items || []}
                  headCells={HEAD_CELLS}
                  filter={filter}
                  total={eventCards?.total || 0}
                  fetching={fetching}
                  heightRow={77}
                  setFilter={setFilter}>
                  <BonusesTableBody
                    data={eventCards?.items}
                    setCurID={setCurID}
                    setIsSuccessModal={() => setIsSuccessModal(true)}
                    setIsOnApproveModal={() => setIsOnApproveModal(true)}
                    setIsApproveModal={() => setIsApproveModal(true)}
                    setIsRejectModal={() => setIsRejectModal(true)}
                    permissions={{
                      update: isAllowedToUpdateBonusCards,
                      retrieve: isAllowedToRetrieveBonusCards,
                      copy: isAllowedToCopyBonusCards,
                      archive: isAllowedToArchiveBonusCards,
                      approve: visibleBySectionPermission(
                        permissions,
                        PERMISSIONS.BONUS.ApproveOrReject.value
                      )
                    }}
                  />
                </EnhancedTable>
              </>
            ) : (
              <NotFoundItems />
            )
          ) : (
            <NotFoundItems message="Вам запрещён доступ к просмотру списка событий" />
          )}

          <CustomModal
            opened={isSuccessModal}
            modalClose={() => setIsSuccessModal(false)}
            modalSubmit={handleArchiver}
            text="Вы действительно хотите перевести данное событие по начислению бонусов в Архив?"
            cancelBtnName="Отмена"
            submitBtnName="Да"
            data-testid="Warning Modal"
          />

          <CustomModal
            opened={isOnApproveModal}
            modalClose={() => setIsOnApproveModal(false)}
            modalSubmit={handleOnApprove}
            text="Вы действительно хотите отправить данное событие на одобрение?"
            cancelBtnName="Отмена"
            submitBtnName="Да"
            data-testid="Warning Modal"
          />

          <CustomModal
            opened={isApproveModal}
            modalClose={() => setIsApproveModal(false)}
            modalSubmit={handleApprove}
            text="Вы действительно хотите одобрить данное событие"
            cancelBtnName="Отмена"
            submitBtnName="Да"
            data-testid="Warning Modal"
          />

          <ModalReason
            showModal={isRejectModal}
            setShowModal={setIsRejectModal}
            submit={handleReject}
          />
        </>
      ) : (
        <PackagesTab />
      )}
    </Box>
  );
};
